import {
  Alert,
  AlertIcon,
  Box,
  Button,
  ButtonGroup,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { Field, Form } from "react-final-form";
import {
  AdaptedCheckboxes,
  AdaptedSelect,
  InputControl,
  MultiLanguageInputControl,
  MultiLanguageTextareaControl,
  Optional,
} from "../components/Form";
import { HealthInsuranceCardType, useBenefitsQuery } from "../graphql";

interface MultiLangString {
  sq: string;
  mk: string;
  en: string;
}

export interface ICreateTierValues {
  name: MultiLangString;
  description: MultiLangString;
  color: string;
  eventsPerMonth: string;
  activeDays: string;
  default: "0" | "1";
  demo: "0" | "1";
  pricePerYear: string;
  benefitIDs: Array<number>;
  sigalHealthInsuranceType: HealthInsuranceCardType;
}

interface ITierForm {
  onSubmit: (values: ICreateTierValues) => void;
  initialValues?: Optional<ICreateTierValues>;
}

export const TierForm: React.FC<ITierForm> = ({ onSubmit, initialValues }) => {
  const validate = (values) => {
    const errors: { [key: string]: string } = {};

    if (!values.name) {
      errors.name = "Fushë e detyruar";
    }

    if (!values.name?.sq || !values.name?.en || !values.name?.mk) {
      errors.name = "Fushë e detyruar";
    }

    if (!values.description) {
      errors.description = "Fushë e detyruar";
    }

    if (
      !values.description?.sq ||
      !values.description?.en ||
      !values.description?.mk
    ) {
      errors.description = "Fushë e detyruar";
    }

    if (!values.color) {
      errors.color = "Fushë e detyruar";
    }
    if (!values.eventsPerMonth) {
      errors.eventsPerMonth = "Fushë e detyruar";
    }
    if (!values.activeDays) {
      errors.activeDays = "Fushë e detyruar";
    }
    if (typeof values.default === "undefined") {
      errors.default = "Fushë e detyruar";
    }
    if (typeof values.demo === "undefined") {
      errors.default = "Fushë e detyruar";
    }
    if (!values.pricePerYear) {
      errors.pricePerYear = "Fushë e detyruar";
    }

    if (!values?.benefitIDs?.length) {
      errors.benefitIDs = "Fushë e detyruar";
    }

    return errors;
  };

  const { data, loading } = useBenefitsQuery();

  return (
    <Form
      onSubmit={onSubmit}
      validate={validate}
      initialValues={initialValues}
      render={({
        handleSubmit,
        form,
        errors,
        submitting,
        pristine,
        values,
      }) => (
        <Box as="form" p={2} onSubmit={handleSubmit}>
          <MultiLanguageInputControl name="name" label="Titulli" />
          <MultiLanguageTextareaControl name="description" label="Pershkrimi" />
          <InputControl type="color" name="color" label="Ngjyra" />
          <InputControl
            type="number"
            name="activeDays"
            label="Kohëzgjatja në ditë"
          />
          <InputControl
            type="number"
            name="eventsPerMonth"
            label="Evente në muaj"
          />
          <InputControl type="number" name="pricePerYear" label="Çmimi" />

          <Field
            name="benefitIDs"
            component={AdaptedCheckboxes}
            label="Përfitimet"
            disabled={loading}
            options={
              data?.benefits.map((i) => ({
                label: i?.title,
                value: i?.id,
              })) || []
            }
          ></Field>

          <Alert status="info" marginBottom={2}>
            <AlertIcon />
            Plotëso fushën më poshtë nëse paketa është e vlefshme për klientet
            Sigal që zotërojnë një nga llojet e policave të sigurimit Gold,
            Silver, Standard.
          </Alert>

          <Field
            name="sigalHealthInsuranceType"
            component={AdaptedSelect}
            label="E parazgjedhur për klientët Sigal me paketë të llojit..."
          >
            <option value="">Asnjë</option>
            <option value="GOLD">GOLD</option>
            <option value="SILVER">SILVER</option>
            <option value="STANDARD">STANDARD</option>
          </Field>

          <Alert status="info" marginBottom={2}>
            <AlertIcon />
            Plotëso fushën më poshtë për tu sigurar që nëse nuk gjendet një
            paketë për llojet e policave Gold, Silver, Standard, kjo mund të
            përdoret si paketa e parazgjedhur.
          </Alert>
          <Field
            name="default"
            component={AdaptedSelect}
            label="E parazgjedhur për klientët Sigal"
          >
            <option value="0">Jo</option>
            <option value="1">Po</option>
          </Field>

          <Alert status="info" marginBottom={2}>
            <AlertIcon />A vlen kjo paketë për rregjistrimet provë?
          </Alert>
          <Field name="demo" component={AdaptedSelect} label="Demo">
            <option value="0">Jo</option>
            <option value="1">Po</option>
          </Field>

          <ButtonGroup spacing={4}>
            <Button
              isLoading={submitting}
              loadingText="Duke dërguar"
              variantColor="teal"
              type="submit"
            >
              Ruaj
            </Button>
            <Button
              variantColor="teal"
              variant="outline"
              onClick={form.reset}
              isDisabled={submitting || pristine}
            >
              Pastro
            </Button>
          </ButtonGroup>
        </Box>
      )}
    />
  );
};
